import React from 'react';
import { Link } from 'react-router-dom';
import AdSlot from '../AdSlot';
import coursesData from '../../data/courses.json';

const CourseSidebar: React.FC = () => {
  const levels = ['Beginner', 'Intermediate', 'Advanced'];
  const featuredCourses = coursesData.filter((course: any) => course.featured).slice(0, 3);

  return (
    <aside className="space-y-6">
      {/* Course Levels */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Course Levels</h3>
        <div className="space-y-2">
          {levels.map((level) => (
            <Link
              key={level}
              to={`/courses?level=${level.toLowerCase()}`}
              className="block px-3 py-2 text-sm text-gray-700 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              {level}
            </Link>
          ))}
        </div>
      </div>

      {/* Featured Courses */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Featured Courses</h3>
        <div className="space-y-3">
          {featuredCourses.map((course: any) => (
            <Link
              key={course.id}
              to={`/course/${course.slug}`}
              className="block group"
            >
              <img
                src={course.thumbnail}
                alt={course.title}
                className="w-full h-24 object-cover rounded-lg mb-2"
              />
              <h4 className="text-sm font-medium text-gray-900 group-hover:text-sky-500 transition-colors line-clamp-2">
                {course.title}
              </h4>
              <div className="flex items-center justify-between mt-1">
                <span className="text-sm font-semibold text-sky-500">${course.price}</span>
                <span className="text-xs text-gray-500">{course.duration}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <AdSlot slot="sidebar" />


      {/* CTA */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-xl border border-sky-200 p-6">
        <h3 className="font-semibold text-gray-900 mb-2">Become an Instructor</h3>
        <p className="text-sm text-gray-600 mb-4">
          Share your knowledge and earn money teaching online.
        </p>
        <Link to="/contact">
          <button className="w-full px-4 py-2 bg-gradient-to-r from-sky-500 to-blue-600 text-white rounded-lg text-sm font-medium hover:shadow-lg transition-all duration-300">
            Apply Now
          </button>
        </Link>
      </div>
    </aside>
  );
};

export default CourseSidebar;